/**
 * ResourceBar — compact display of user's gamification resources.
 * Shows: 🪣 watering_cans · 💧 waterings · 🌿 active_fertilizers
 *
 * Props:
 *   resources  { watering_cans, waterings, active_fertilizers }
 *   size       'sm' | 'md' | 'lg'  (default 'md')
 *   className  string
 */

const SIZE_CLASSES = {
  sm: "text-xs gap-2 px-2 py-1",
  md: "text-sm gap-3 px-3 py-1.5",
  lg: "text-base gap-4 px-4 py-2",
};

export default function ResourceBar({ resources = {}, size = "md", className = "" }) {
  const { watering_cans = 0, waterings = 0, active_fertilizers = 0 } = resources;
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div
      className={`inline-flex items-center rounded-full bg-white/10 backdrop-blur-sm border border-white/20 font-medium text-white ${sizeClass} ${className}`}
    >
      <ResourceItem emoji="🪣" value={watering_cans} label="Regadores" max={10} />
      <Divider />
      <ResourceItem emoji="💧" value={waterings} label="Regas" max={10} />
      <Divider />
      <ResourceItem emoji="🌿" value={active_fertilizers} label="Adubos" max={5} />
    </div>
  );
}

function ResourceItem({ emoji, value, label, max }) {
  const isFull = value >= max;

  return (
    <span
      className={`flex items-center gap-1 tabular-nums transition-colors ${
        isFull ? "text-yellow-300" : ""
      }`}
      title={`${label}: ${value}/${max}`}
    >
      <span className="leading-none">{emoji}</span>
      <span>{value}</span>
    </span>
  );
}

function Divider() {
  return <span className="opacity-30 select-none">·</span>;
}
